import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col gap-12px" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row-top gap-10" }
const _hoisted_4 = { class: "col gap-12px" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col gap-12px" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row-top gap-10" }

import esHealthProSearch from './esHealthProSearch.vue';

import { useI18n } from "vue-i18n";
import patientChange from '@/views/mainMenu/patientChange.vue';
import entourageInput from "@/views/patientMain/dashbAdmin/person/entouragePersonInput.vue"
import officeapi from "@/api/officeapi";
import { ref, computed } from 'vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import EsDataCard from '@/components/esDataCard.vue';
import {toastError} from "@/utils/toast-utils";
import {useToast} from "primevue";
import PersonService from "@/services/PersonService";


export default /*@__PURE__*/_defineComponent({
  __name: 'esRelationship',
  setup(__props) {

const { t } = useI18n();
const dropd = ref("");
const currentEntryStore = useCurrentEntryStore();
const toast = useToast();

async function addPwrPersonToPwrPatient(pwr) {
  dropd.value = '';
  const pwrPersonId = pwr.patientId;
  const pwrPatientId = currentEntryStore.modalPatient.personWithRoleId;
  try {
    await officeapi.addPwrPersonToPwrPatient(pwrPatientId, pwrPersonId);
  } catch (error: any) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: error.status ? t(`error.${error.status}`) : t('error.DEFAULT')
    });
  }
  await currentEntryStore.reloadPatientOnly();
}

const sortedRelatives = computed(() => {
  const ret = currentEntryStore.modalPatient?.relatives;
  ret.sort((a, b) =>
    a.lastName.localeCompare(b.lastName) ||
    a.firstName.localeCompare(b.firstName)
  )
  return ret;
});

function reload() {
  currentEntryStore.reloadPatientOnly();  
  dropd.value = ''
}

function closeFctAndDelete(item) {
  currentEntryStore.deleteRelativeFromCurrentPatient(item);
  dropd.value = ''
}

async function accessPatient(pwrPatient: any) {
  const patientId = pwrPatient.personWithRoleId;
  await currentEntryStore.setModalPatient(patientId);
}


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_dropdownBox = _resolveComponent("dropdownBox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.relationship.privatePatient'),
          class: "h4 mleft-02"
        }, null, 8, ["txt"]),
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dropd).value = $event)),
          openOn: "RelativePlus"
        }, {
          dropd: _withCtx(() => [
            _createVNode(patientChange, {
              "exclude-patients": [_unref(currentEntryStore).modalPatient.personWithRoleId],
              onSelectedPatient: addPwrPersonToPwrPatient
            }, null, 8, ["exclude-patients"])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_button_group, { styles: "pad-m" }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "plus",
                  styles: "size-l main-l"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedRelatives.value, (pwrRelative, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (pwrRelative.personRoleType === 'CustomPatient')
              ? (_openBlock(), _createBlock(_component_dropdownBox, {
                  key: 0,
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
                  openOn: 'input-'+index,
                  class: "cursor-action"
                }, {
                  dropd: _withCtx(() => [
                    _createVNode(entourageInput, {
                      person: pwrRelative,
                      ref_for: true,
                      ref: 'input-'+index,
                      onClose: ($event: any) => (closeFctAndDelete(pwrRelative))
                    }, null, 8, ["person", "onClose"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(EsDataCard, {
                      title: _unref(PersonService).formatName(pwrRelative.lastName, pwrRelative.firstName),
                      icon: 'person_fill',
                      folderIcon: 'shareIcons',
                      ref_for: true,
                      ref: 'relationship-' + index,
                      backgroundClass: "bg-blue-04",
                      onIconClick: ($event: any) => (accessPatient(pwrRelative))
                    }, {
                      default: _withCtx(() => [
                        (pwrRelative.relation?.description)
                          ? (_openBlock(), _createBlock(_component_text_item, {
                              key: 0,
                              txt: pwrRelative.relation?.description,
                              class: "pleft-30px txt-grey-64"
                            }, null, 8, ["txt"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["title", "onIconClick"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "openOn"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "w-full border-top" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.relationship.privateCustom'),
          class: "h4 mleft-02"
        }, null, 8, ["txt"])
      ])
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "w-full border-top" }, null, -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('patient.admin.relationship.healthPro'),
          class: "h4 mleft-02"
        }, null, 8, ["txt"]),
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dropd).value = $event)),
          openOn: "HealthProSearch"
        }, {
          dropd: _withCtx(() => [
            _createVNode(esHealthProSearch, {
              onAfterAddingPwr: _cache[2] || (_cache[2] = ($event: any) => (reload()))
            })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_button_group, {
              styles: "pad-m",
              class: "mleft-04"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_svg_item, {
                  icon: "plus",
                  styles: "size-l main-l"
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedRelatives.value, (pwrRelative, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
            (pwrRelative.personRoleType === 'CustomHealthPro')
              ? (_openBlock(), _createBlock(_component_dropdownBox, {
                  key: 0,
                  modelValue: dropd.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dropd).value = $event)),
                  openOn: 'input-'+index,
                  class: "cursor-action"
                }, {
                  dropd: _withCtx(() => [
                    _createVNode(entourageInput, {
                      person: pwrRelative,
                      ref_for: true,
                      ref: 'input-'+index,
                      onClose: ($event: any) => (closeFctAndDelete(pwrRelative))
                    }, null, 8, ["person", "onClose"])
                  ]),
                  default: _withCtx(() => [
                    _createVNode(EsDataCard, {
                      title: _unref(PersonService).formatName(pwrRelative.lastName, pwrRelative.firstName),
                      icon: 'person_fill',
                      folderIcon: 'shareIcons',
                      ref_for: true,
                      ref: 'relationship-' + index,
                      backgroundClass: "bg-blue-04"
                    }, {
                      default: _withCtx(() => [
                        (pwrRelative.relation?.description)
                          ? (_openBlock(), _createBlock(_component_text_item, {
                              key: 0,
                              txt: pwrRelative.relation?.description,
                              class: "pleft-30px txt-grey-64"
                            }, null, 8, ["txt"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["title"])
                  ]),
                  _: 2
                }, 1032, ["modelValue", "openOn"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ])
  ], 64))
}
}

})